export const CurrencyFormat = (number) => {
  if(!(number || number === 0)) return "";

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "USD",
  }).format(number);
}